import React from "react";
import Table from "../../../components/Table";
import { HuidigeSituatieHypotheek } from "../../../../../.generated/rapportage/rapportagetypes";
import { getHypothekenColumns } from "../../Producten/hypotheken-kolommen";

export interface HypothekenTableProps {
  data: HuidigeSituatieHypotheek[];
}

export const HypothekenTable: React.FC<HypothekenTableProps> = ({
  data,
}: HypothekenTableProps) => {
  // Split data into chunks of maximum 3 rows
  const chunkSize = 3;
  const chunks: typeof data[] = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunks.push(data.slice(i, i + chunkSize));
  }
  
  return (
    <>
      {chunks.map((chunk, index) => (
        <Table
          key={`hypotheken-table-${index}`}
          columns={getHypothekenColumns()}
          data={chunk}
          rotate={true}
          showHeader={true}
          filterNullAnd0Columns={true}
          id={`hypotheken-table-${index}`}
          extraStyle="break-inside: avoid; page-break-inside: avoid;"
          regularStyles={chunk?.length > 1}
        />
      ))}
    </>
  );
};
